module.exports = __webpack_public_path__ + "static/dada-4d1e22eb565bdc18e9ce8f9b1721a3fc.png";